import type { UpdateFavorite } from '~/features/favorites' // FIXME: avoid importing from other features
import type { SendEventParams } from '~/shared/analytix'

import { createWatch } from 'effector'
import { model as favoritesModel } from '~/features/favorites' // FIXME: avoid importing from other features
import { SnapshotMap } from '../../general/snapshot-map'

const SNAPSHOTS_TO_KEEP = 1

type Type = 'tv' | 'vod' | 'tvshow'
export type FavoriteRemoveParameters = SendEventParams.FavoriteRemove & { contentType?: Type } // prettier-ignore

/**
 * SnapshotMap to store `favorite_remove` event parameters with their history
 */
export const parameters = new SnapshotMap<FavoriteRemoveParameters>(
  SNAPSHOTS_TO_KEEP
)

//
// Update parameters
//

function fromParams(params: Omit<UpdateFavorite, 'type'> & { type: Type }) {
  parameters
    .update('contentId', String(params.id))
    .update('contentType', params.type)
    .update('contentName', params.name)
    .commit()
    .notify()
}

//
// Updates listeners
//

// on tv channel removed from favorites
createWatch({
  unit: favoritesModel.favoriteTvChannelFx.done,
  fn({ params }) {
    if (!params.favorite) {
      fromParams({ ...params, type: 'tv' })
    }
  },
})

// on vod removed from favorites
createWatch({
  unit: favoritesModel.favoriteVodFx.done,
  fn({ params }) {
    if (!params.favorite) {
      fromParams({ ...params, type: 'vod' })
    }
  },
})

// on tv show removed from favorites
createWatch({
  unit: favoritesModel.favoriteTvShowFx.done,
  fn({ params }) {
    if (!params.favorite) {
      fromParams({ ...params, type: 'tvshow' })
    }
  },
})
